import { useLazyLoadQuery } from 'react-relay';

import BylineSmartLinksQuery, {
	type BylineSmartLinksQuery as BylineSmartLinksQueryType,
} from '../queries/__generated__/BylineSmartLinksQuery.graphql.ts';
import { MAX_BYLINE_CONNECTION_ICONS } from '../utils/getBylineConnectionIcons.ts';

import {
	normalizeOutboundBylineSsrState,
	type OutboundBylineSsrState,
} from './outboundBylineSsrState.ts';

/**
 * Reserves byline icon tiles before paint, so the placeholder and the loaded byline occupy the same
 * space.
 *
 * `store-only` because this renders inside the loading placeholder: suspending or fetching would
 * stall the very thing covering the wait. Variables must match `preloadOutboundBylineSsrState`, or
 * the read silently misses the preloaded entry and reserves nothing.
 */
export const useOutboundBylineSsrState = (
	contentId: string | undefined,
): OutboundBylineSsrState | undefined => {
	const data = useLazyLoadQuery<BylineSmartLinksQueryType>(
		BylineSmartLinksQuery,
		{
			contentId: contentId ?? '',
			first: MAX_BYLINE_CONNECTION_ICONS,
			smartLinksFromDraft: false,
		},
		{ fetchPolicy: 'store-only' },
	);

	if (contentId === undefined) {
		return undefined;
	}

	return normalizeOutboundBylineSsrState(contentId, data);
};
